// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_SERVICE_ACCOUNTS } from "./action";

export function canListServiceAccounts(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_SERVICE_ACCOUNTS);
}
